<section class="login-section" *ngIf="isBrowser">
  <div class="login-wrapper">
    <div class="login-wrapper-inner">
    <div class="logo">
      <a href="javascript:void(0)">
        <img [src]="brandLogo" alt="Crizac" title="Crizac" class="logo-img" />
      </a>
      <h2>Employee Portal</h2>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
      <!-- Username -->
      <div class="form-group">
        <label for="username">E-mail Address</label>
        <mat-form-field appearance="fill" class="full-width">
          <input matInput autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"
            placeholder="Enter e-mail address" formControlName="username" id="username" (input)="onEmailInput($event)" />
        </mat-form-field>
        <div class="error" *ngIf="loginForm.get('username')?.touched && loginForm.get('username')?.invalid">
          <div *ngIf="loginForm.get('username')?.hasError('required')">Email is required</div>
          <div *ngIf="loginForm.get('username')?.hasError('email')">Please enter a valid email address</div>
        </div>
      </div>
      <!-- Password -->
      <div class="form-group">
        <label for="password">Password</label>
        <mat-form-field appearance="fill" class="full-width">
          <input matInput [type]="hidePassword ? 'password' : 'text'" autocomplete="off" autocorrect="off"
            autocapitalize="off" spellcheck="false" placeholder="Enter password" formControlName="password" id="password"
            (input)="onPasswordInput($event)" />
      
          <!-- Toggle button -->
          <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword"
            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>
      
        <!-- Error Messages -->
        <div class="error" *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.invalid">
          <div *ngIf="loginForm.get('password')?.hasError('required')">
            Password is required
          </div>
          <div *ngIf="loginForm.get('password')?.hasError('minlength')">
            Minimum 8 characters required
          </div>
          <!-- Removed pattern validation message -->
        </div>
      </div>


      <div class="row mb-15">
        <div class="col-6"> 
          <mat-checkbox formControlName="remember" class="mt-5 remember-me">Remember Me</mat-checkbox>
        </div> 
        <div class="col-6">
          <button class="float-end" mat-button type="button" (click)="openDialog()">Forgotten Password?</button>
        </div>
      </div>
      
      <!-- Login Button with Dynamic Styling -->
      <button 
        class="full-width" 
        mat-raised-button 
        type="submit" 
        [disabled]="loginForm.invalid"
        [style.background-color]="(loginForm.invalid ? buttonDisabledBgColor : buttonBgColor) + ' !important'"
        [style.color]="(loginForm.invalid ? buttonDisabledTextColor : buttonTextColor) + ' !important'">
        Login
      </button>
      
      <p class="txt-copyright text-center">© {{currentYear}} {{companyName}}. All rights reserved.</p>

      <!-- <div class="form-group">
        <label for="username">Username</label>
        <input
          type="text"
          id="username"
          class="form-control"
          formControlName="username"
          placeholder="Enter username"
        />
        <div class="error" *ngIf="loginForm.get('username')?.invalid && loginForm.get('username')?.touched">
          Username is required
        </div>
      </div> -->

      <!-- Password -->
      <!-- <div class="form-group">
        <label for="password">Password</label>
        <input
          type="password"
          id="password"
          class="form-control"
          formControlName="password"
          placeholder="Enter password"
        />
        <div class="error" *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
          Password is required
        </div>
      </div> -->

      <!-- Submit Button -->
      <!-- <button class="btn btn-primary" type="submit" [disabled]="loginForm.invalid">
        Login
      </button> -->
    </form>
  </div>
</div>
</section>